import { Pill, Text } from '@fullstory/components';
import React, { PropsWithChildren } from 'react';

interface PillTextProps {
  noExternalSpacing?: React.ComponentProps<typeof Pill>['noExternalSpacing'];
}

export const PillText: React.FC<PropsWithChildren<PillTextProps>> = ({
  noExternalSpacing,
  children,
}) => (
  <Pill data-component="PillText" variant="primary" noExternalSpacing={noExternalSpacing}>
    <Text appearance="bodySmall" tag="span">
      {children}
    </Text>
  </Pill>
);
